<template>
  <div class="w-full inline-flex flex-col justify-center overflow-auto">
    <div v-if="bestStops.length" class="mb-4">
      <div

        v-for="(line, k) in bestStops"
        :key="`stops-${line.id}`"
        @click="
          selectLocation({ ...line, place_name_fr: `Arrêt ${line.name}` })
        "
      >
        <Location
          :name="line.name"
          type="bus"
          :class="{
            'border-b-2 border-gray-200 dark:border-slate-700':
              bestStops.length > 1
          }"
        />
      </div>
    </div>

    <div v-if="publicPlaces.length" class="mb-4">
      <div

        v-for="(place, k) in publicPlaces"
        :key="`places-${place.id}`"
        @click="selectLocation({ ...place, place_name_fr: place.name })"
      >
        <Location
          :name="place.name"
          type="marker"
          :class="{
            'border-b-2 border-gray-200 dark:border-slate-700':
              publicPlaces.length > 1
          }"
        />
      </div>
    </div>

    <div v-if="addresses.length" class="mb-4">
      <div

        v-for="(address, k) in addresses"
        :key="`address-${address.id}`"
        @click="
          selectLocation({ ...address, place_name_fr: addressName(address) })
        "
      >
        <Location
          :name="addressName(address)"
          type="marker"
          :class="{
            'border-b-2 border-gray-200 dark:border-slate-700':
              addresses.length > 1
          }"
        />
      </div>
    </div>

    <Infos class="p-4" size="large" />
  </div>
</template>

<script>
import Infos from "@/components/Infos.vue";

import Location from "@/components/itineraire/Location.vue";

Array.prototype.naturalSort = function() {
  var a,
    b,
    a1,
    b1,
    rx = /(\d+)|(\D+)/g,
    rd = /\d+/;
  return this.sort(function(as, bs) {
    a = String(as)
      .toLowerCase()
      .match(rx);
    b = String(bs)
      .toLowerCase()
      .match(rx);
    while (a.length && b.length) {
      a1 = a.shift();
      b1 = b.shift();
      if (rd.test(a1) || rd.test(b1)) {
        if (!rd.test(a1)) return -1;
        if (!rd.test(b1)) return 1;
        if (a1 != b1) return a1 - b1;
      } else if (a1 != b1) return a1 > b1 ? 1 : -1;
    }
    return a.length - b.length;
  });
};

export default {
  name: "SearchPlace",
  components: {
    Location,
    Infos
  },
  computed: {
    places() {
      return (
        this.$store.state.itineraire.search[
          this.$store.state.itineraire.onSearch
        ] || {}
      );
    },
    bestStops() {
      if (!this.places.best_place) {
        return [];
      }
      return (
        (
          this.places.best_place.filter(a => a.stops !== null)[0].stop || []
        ).filter(
          place =>
            place.name
              .toLowerCase()
              .indexOf(this.$store.state.itineraire.query.toLowerCase()) !== -1
        ) || []
      );
    },
    bestRoads() {
      if (!this.places.best_place) {
        return [];
      }
      return this.places.best_place.filter(a => a.road !== null)[0].road || [];
    },
    roads() {
      if (!this.places.roads) {
        return [];
      }
      return this.places.roads.filter(a => a.road !== null)[0].road || [];
    },
    addresses() {
      if (!this.places.addresses) {
        return [];
      }
      return (
        this.places.addresses.filter(a => a.address !== null)[0].address || []
      );
    },
    publicPlaces() {
      if (!this.places.public_places) {
        return [];
      }
      const publicPlaces = this.places.public_places[0].public_place;
      const places = [...publicPlaces]
        .concat(this.bestRoads)
        .concat(this.roads)
        .filter(Boolean);

      return (
        places
          .filter(({ levenshtein }) => levenshtein < 60)
          .filter(
            place =>
              place.name
                .toLowerCase()
                .indexOf(this.$store.state.itineraire.query.toLowerCase()) !==
              -1
          )
          .sort((a, b) => {
            if (a.city_id === this.clermontCityId) {
              return a.levenshtein < b.levenshtein ? 1 : 0;
            }

            return a.levenshtein < b.levenshtein ? 0 : -1;
          })
          // .sort((a, b) => a.city_id === this.clermontCityId ? -1 : 1)
          // .sort((a, b) => a.levenshtein < b.levenshtein ? -1 : 1)
          .map(place => {
            if (place.city_id !== this.clermontCityId) {
              place.name = place.key;
            }
            return place;
          }) || []
      );
    }
  },
  data() {
    return {
      clermontCityId: "1688849860563049"
    };
  },
  methods: {
    async selectLocation(location) {
      this.$store.commit("itineraireSelect", location);
      await this.$store.dispatch("findJourney");
    },
    addressName(address) {
      let city = "";
      if (address.road_city_id !== this.clermontCityId) {
        city = `${address.road_city_name} - `;
      }

      return `${city}${address.number} ${address.road_name}`;
    }
  }
};
</script>
